import { inject } from 'inversify';
import { appendToFormData, urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IScan } from '../interfaces';
import { ScanMapper } from '../mappers';

export type IScanTrackingCodeRepoResponse = IRepoResponse<200, IScan> | IRepoResponse<400 | 422 | 500, string>;

export type IScanTrackingCodeRepo = IRepo<[string, { track_code: string }], IScanTrackingCodeRepoResponse>;

export const ScanTrackingCodeRepoType = Symbol.for('ScanTrackingCodeRepo');

@bind(ScanTrackingCodeRepoType)
export class ScanTrackingCodeRepo implements IScanTrackingCodeRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string, data: { track_code: string }) {
    try {
      const body = new FormData();
      appendToFormData(data, body);
      const url = urlMaker(`/api/admin/branch_inspections/${id}/scan`);

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        const scanData: IScan = ScanMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: scanData,
        };
      } else if (result.status === 422) {
        const errors = result.data.errors;
        const errorMessage = Object.values(errors).flat().join(', ');
        return {
          status: 422 as 422,
          response: errorMessage,
        };
      } else {
        return {
          status: 400 as 400,
          response: result.data.message || 'Məlumat əlavə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
